import { useQuery } from 'react-query'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom-v5-compat'
import { companySupportOrganization } from 'shared/api/companyHttp'
import { getCompanyBranding } from 'shared/api/organizations'
import { loginDestination } from 'shared/helpers/passwordlessLogin'

import { currentUserSelector } from '../../../redux/selectors/users'
import { ApplicationState } from '../../../redux/store/models'

const uuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

export function useCompanyBranding() {
  const user = useSelector(currentUserSelector)
  const authenticated = useSelector((state: ApplicationState) => state.auth.isAuthenticated)
  const location = useLocation()
  const destination = new URL(loginDestination(location.search), window.location.origin)
  const supplied =
    new URLSearchParams(location.search).get('company') ?? destination.searchParams.get('company')
  const selected = supplied && uuid.test(supplied) ? supplied : ''
  const id = authenticated ? (user.is_staff ? companySupportOrganization() : user.organization) : selected
  const query = useQuery(['company-branding', id], () => getCompanyBranding(id!), {
    enabled: Boolean(id),
    retry: false,
    staleTime: 0,
    refetchInterval: 60000,
  })
  return id && !query.isError ? query.data : undefined
}
